import { CalendarEventDetails, CalendarEventRef } from '@griply/types';
import { sanitizeCalendarEventDetails } from '@griply/utils';

import { FirebaseHttpsCallableFactory } from '../types/firebase-functions';

export type GetExternalCalendarEventPayload = CalendarEventRef;

type GetExternalCalendarEventResult = { event: CalendarEventDetails | null };

export type GetExternalCalendarEventOptions<TFunctions> = {
  functions: TFunctions;
  httpsCallable: FirebaseHttpsCallableFactory<TFunctions>;
  payload: GetExternalCalendarEventPayload;
};

export const getExternalCalendarEvent = async <TFunctions>(
  options: GetExternalCalendarEventOptions<TFunctions>,
): Promise<CalendarEventDetails | null> => {
  const { functions, httpsCallable, payload } = options;
  const callable = httpsCallable<
    GetExternalCalendarEventPayload,
    GetExternalCalendarEventResult
  >(functions, 'externalCalendars-getEvent');

  const { data } = await callable(payload);

  if (!data.event) {
    return null;
  }

  return sanitizeCalendarEventDetails(data.event);
};
